/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'form': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M800 928H224c-52.928 0-96-43.072-96-96V192c0-52.928 43.072-96 96-96h576c52.928 0 96 43.072 96 96v640c0 52.928-43.072 96-96 96zM224 160c-17.632 0-32 14.368-32 32v640c0 17.664 14.368 32 32 32h576c17.664 0 32-14.336 32-32V192c0-17.632-14.336-32-32-32H224z"/><path pid="1" d="M640.992 544.864H287.776c-17.664 0-32-14.336-32-32s14.336-32 32-32h353.216c17.696 0 32 14.336 32 32s-14.304 32-32 32zM734.88 735.52H287.648c-17.664 0-32-14.304-32-32s14.336-32 32-32H734.88c17.696 0 32 14.304 32 32s-14.304 32-32 32zM255.712 305.344a1.5 1.5 0 1096 0 1.5 1.5 0 10-96 0zM463.104 305.344a1.5 1.5 0 1096 0 1.5 1.5 0 10-96 0zM671.232 305.344a1.5 1.5 0 1096 0 1.5 1.5 0 10-96 0z"/>'
  }
})
